import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import GraduateAdmissionApplication from '../../menforms/form/GraduateAppGTSU'
// import Mayor from '../../menhome/Mayor'
// import Second from '../../menhome/Client'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="GTSU Graduate Admissions Application || Forms";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Forms"
            title="GTSU Graduate Admissions Application"
            subtitledown="GTSU Graduate Admissions Application"
           />
            <GraduateAdmissionApplication/>
            {/* <Mayor/>
            <Second/> */}
        </div>
    </>
  )
}

export default Main